import { OnsitePropertyContactName } from './components/OnsitePropertyContactName';
import { OnsitePropertyContactEmail } from './components/OnsitePropertyContactEmail';
import { OnsitePropertyContactPhone } from './components/OnsitePropertyContactPhone';

interface OnsitePropertyContactInformationProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const OnsitePropertyContactInformation: React.FC<OnsitePropertyContactInformationProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    return (
        <>
            {isReview ? (
                <>
                    <OnsitePropertyContactName
                        propertyGuid={propertyGuid}
                        required={required}
                        isReview={isReview}
                    />
                    <OnsitePropertyContactEmail
                        propertyGuid={propertyGuid}
                        required={required}
                        isReview={isReview}
                    />
                    <OnsitePropertyContactPhone
                        propertyGuid={propertyGuid}
                        required={required}
                        isReview={isReview}
                    />
                </>
            ) : (
                <div style={{ marginTop: '30px' }}>
                    <div className='pageSubHeader'>Property Contact Information</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <OnsitePropertyContactName
                            propertyGuid={propertyGuid}
                            required={required}
                            isReview={isReview}
                        />
                        <OnsitePropertyContactEmail
                            propertyGuid={propertyGuid}
                            required={required}
                            isReview={isReview}
                        />
                        <OnsitePropertyContactPhone
                            propertyGuid={propertyGuid}
                            required={required}
                            isReview={isReview}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
